module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticStyle: {
      "padding-bottom": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "editForm",
    staticStyle: {
      "min-height": "450px"
    },
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Import")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Site:",
      "prop": "site"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Site"
    },
    model: {
      value: (_vm.sitecode),
      callback: function($$v) {
        _vm.sitecode = $$v
      },
      expression: "sitecode"
    }
  }, _vm._l((_vm.sites), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.code + ' - ' + item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "XML : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "type": "textarea",
      "rows": "30"
    },
    model: {
      value: (_vm.xmldata),
      callback: function($$v) {
        _vm.xmldata = $$v
      },
      expression: "xmldata"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('br'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "Upload"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.Upload.apply(null, arguments)
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "default",
      "icon": "edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeForm.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15c9733c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/Dossier_import.vue
// module id = 633
// module chunks = 1